import { cn } from "@/lib/utils";

/** Bordered segmented control, 26px tall — period switcher, run filters. */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  size = "sm",
  bordered = true,
  className,
  "aria-label": ariaLabel,
}: {
  value: T;
  onChange: (next: T) => void;
  options: Array<{ value: T; label: string }>;
  size?: "sm" | "xs";
  bordered?: boolean;
  className?: string;
  "aria-label"?: string;
}) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={cn(
        "inline-flex items-center rounded-md p-[2px]",
        bordered && "h-[26px] border border-border",
        className,
      )}
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(o.value)}
            className={cn(
              "rounded-[4px] font-medium transition-colors",
              size === "sm" ? "px-[9px] py-[2px] text-[11.5px]" : "px-2 py-px text-[11px]",
              active
                ? "bg-surface-hover text-text-primary"
                : "text-text-secondary hover:text-text-primary",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
